import arrayReduce from 'fast-loops/lib/arrayReduce';

export default function processStyleWithPlugins(renderer, style, type) {
  var props = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (renderer.plugins.length > 0) {
    return arrayReduce(renderer.plugins, function (processedStyle, plugin) {
      return plugin(processedStyle, type, renderer, props);
    }, style);
  }

  return style;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-tools/node_modules/fela-utils/es/processStyleWithPlugins.js
// module id = 720
// module chunks = 0